<template>
  <div>
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>Login</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-form>
          <v-text-field prepend-icon="person" name="email" label="email" type="text" v-model="email" placeholder=" "></v-text-field>
          <v-text-field prepend-icon="lock" name="password" label="Password" id="password" type="password"
                        v-model="password" placeholder=" "></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="login(email, password, remember_me)">Login</v-btn>
      </v-card-actions>
    </v-card>
  </div>

</template>

<script>
  export default {
    layout: 'dashboard_guest',
    data() {
      return {
        email: '',
        password: '',
        remember_me: false
      }
    },
    methods: {
      async login(email, password, remember_me) {
        let result = await this.$store.dispatch('graph/login', [email, password, remember_me]);
        if (result && result.result === 'ok') {
          window.location = this.$router.resolve({
            name: 'dashboard',
            params: {}
          }).href;
        }
      }
    }
  }
</script>
